import {
    Component,
    ElementRef,
    EventEmitter
} from '@angular/core';
import { Item } from '../../../../baseObjects/item';

@Component({
    selector: 'container-item',
    templateUrl: 'container-item.nested.html'
})
export class ContainerItemComponent extends Item {
    constructor(public elementRef: ElementRef) {
        super();
        this.onClick = new EventEmitter<any>();
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/container/nested/item/container-item.nested.ts